import moment from "moment-timezone";

export const validateEventUrl = (url: string): boolean => {
  const validUrl = url.startsWith("https://");
  const supportedSite =
    url.includes("seatgeek") ||
    url.includes("stubhub") ||
    url.includes(".ticketmaster.") ||
    url.includes("livenation") ||
    url.includes("tickpick") ||
    url.includes("vividseats");
  return validUrl && supportedSite;
};

export const cleanUrl = (inputUrl: string): string => {
  if (!inputUrl.includes("stubhub")) {
    return inputUrl.trim().split("?")[0].split("#")[0];
  }
  return inputUrl.trim();
};

export const getExpirationDate = (date: string): Date => {
  return moment
    .tz(date, "YYYY-MM-DD", "Europe/London")
    .endOf("day")
    .clone()
    .utc()
    .toDate();
};
